/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: MediaPage
 * Page name: media
 * Page Description: This is the media page of the website of Ekathva Innovations.
 */

import React, { useEffect } from "react";
import MetaTags from "react-meta-tags";
import { SRLWrapper } from "simple-react-lightbox";
import { Row, Col } from "react-bootstrap";

import Navbar from "components/Navbars/Navbar";
import LandingPageMedia from "components/Headers/LandingPageMedia";
import Footer from "components/Footers/Footer";
import "assets/style/Style.css";

import IMG1 from "assets/images/Media/IMG1.jpg";
import IMG2 from "assets/images/Media/IMG2.JPG";
import IMG3 from "assets/images/Media/IMG3.JPG";
import IMG4 from "assets/images/Media/IMG4.jpg";
import IMG5 from "assets/images/Media/IMG5.jpg";
import IMG6 from "assets/images/Media/IMG6.JPG";
import IMG7 from "assets/images/Media/IMG7.jpg";
import IMG9 from "assets/images/Media/IMG9.jpg";
import IMG10 from "assets/images/Media/IMG10.png";
import IMG12 from "assets/images/Media/IMG12.jpg";
import IMG13 from "assets/images/Media/IMG13.jpg";
import IMG14 from "assets/images/Media/IMG14.jpg";
import IMG15 from "assets/images/Media/IMG15.jpg";
import IMG16 from "assets/images/Media/IMG16.jpg";
import IMG19 from "assets/images/Media/IMG19.jpg";
import IMG20 from "assets/images/Media/IMG20.jpg";
import IMG21 from "assets/images/Media/IMG21.jpeg";
import IMG23 from "assets/images/Media/IMG23.jpg";
import IMG24 from "assets/images/Media/IMG24.jpg";
import IMG25 from "assets/images/Media/IMG25.jpeg";
import IMG27 from "assets/images/Media/IMG27.jpg";
import IMG28 from "assets/images/Media/IMG28.jpeg";

function MediaPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <MetaTags>
        <title>
          Media coverage and Achievements gallery | Ekathva Innovations Pvt Ltd
        </title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
      </MetaTags>

      <Navbar />
      <LandingPageMedia />
      <div className="aboutus_mainspace">
        <SRLWrapper>
          <Row className="cursor">
            <Col>
              <img
                src={IMG1}
                alt="Ekathva Innovations, incorporated on 26th June 2018"
              />
            </Col>

            <Col>
              <img
                src={IMG2}
                alt="Started our operations on 2nd July 2018 with divine blessings"
              />
              <br />
              <br />
              <img
                src={IMG3}
                alt="On the occasion of inaugurations, with the management and staffs of JNNCE, Shivamogga"
              />
            </Col>

            <Col>
              <img
                src={IMG4}
                alt="Website development workshop at DSDN, Shivamogga."
              />
            </Col>

            <Col>
              <img
                src={IMG5}
                alt="GDB Product Launch during the National Level student symposium, PLASMA-2018 at JNNCE, Shivamogga"
              />
              <br />
              <br />
              <img
                src={IMG6}
                alt="At Karnataka Tech-Entrepreneurship Summit KTES-2019"
              />
            </Col>
          </Row>
          <br />
          <br />
          <Row className="cursor">
            <Col>
              <img
                src={IMG7}
                alt="Two days hands-on workshop on web development and IoT"
              />
              <br />
              <br />
              <img
                src={IMG9}
                alt="Knowledge sharing session on technology innovation in farming at UAHS, Shivamogga"
              />
            </Col>

            <Col>
              <img
                src={IMG10}
                alt="Honored during 2 days national symposium, ISVM conference 2020 at Hebbal, Bengaluru"
              />
            </Col>

            <Col>
              <img
                src={IMG12}
                alt="Sharing the company's journey to budding entrepreneurs at Startup Karnataka Bootcamp 2019"
              />
            </Col>

            <Col>
              <img
                src={IMG13}
                alt="Honored during Startup Karnataka Bootcamp 2019"
              />
            </Col>
          </Row>
          <Row className="cursor">
            <Col>
              <img
                src={IMG14}
                alt="Ekathva Innovations recognized as a startup by Govt of India"
              />
              <img
                src={IMG23}
                alt="During the inauguration of Ekathva - JNNCE Collaborated knowledge sharing through an industrial internship program at JNNCE, Shivamogga"
              />
            </Col>
            <Col>
              <img
                src={IMG15}
                alt="Ekathva Innovations recognized as a startup by Govt of Karnataka"
              />
            </Col>
            <Col>
              <img
                src={IMG16}
                alt="Two days Hands-on Robotics and automation workshop for BE students"
              />
              <br />
              <br />
              <img
                src={IMG19}
                alt="Ekathva’s AgriTech Product demonstration to farmers at Dharwad Krushi mela - 2020"
              />
            </Col>
            <Col>
              <img
                src={IMG20}
                alt="At Karnataka Tech-Entrepreneurship Summit  KTES -2020 with Dr. AshwathNarayan, DCM, Government of Karnataka"
              />
              <br />
              <br />
              <img
                src={IMG21}
                alt="At Startup street event, organized by Malnad College of Engineering, Hassan"
              />
            </Col>
          </Row>
          <Row className="cursor">
            <Col>
              <img
                src={IMG25}
                alt="National Media, ANI tweeted the report about the automatic sanitizer dispenser innovation carried out by team Ekathva during the covid pandemic"
              />
            </Col>
            <Col>
              <img
                src={IMG24}
                alt="Demonstration of automatic sanitizer dispenser product to BEO, Shivamogga during the preparation of Karnataka SSLC exams 2020"
              />
              <br />
              <br />
              <img
                src={IMG27}
                alt="At the Incubation Cohort inauguration event at Deshpande Startups, Hubballi"
              />
            </Col>
            <Col>
              <img
                src={IMG28}
                alt="Appreciation by Sri Ayanur Manjunath, Member of Legislative Council, Govt of Karnataka"
              />
            </Col>
            <Col></Col>
          </Row>
        </SRLWrapper>
      </div>
      <Footer />
    </div>
  );
}

export default MediaPage;
